<template>
  <div class="post">
    <!-- 头像 -->
    <div class="post__avatar">
      <!-- <img :src="`${dic.owner.avatar}`" /> -->
      <!-- <img class="post__avatar__bg" v-if="dic.owner.segment&&dic.owner.segment.image" :src="getImg(dic.owner.segment.image)" /> -->
      <img class="post__avatar__img" :src="getImg(dic.owner.avatar)" />
    </div>
    <div class="postView" ref="postView">
      <div class="postView__post">
        <label class="postView__post__name" @click.stop="jumpToProfile()" :title="dic.owner.realname">
          <span class="name">{{dic.owner.name}}</span>
          <span class="postView__post__segment" v-if="dic.owner.segment&&dic.owner.segment.name">[{{dic.owner.segment&&dic.owner.segment.name}}]</span>
          <span class="postView__post__sticky" v-if="dic.is_top">置顶</span>
          <span class="postView__post__essence" v-if="dic.is_essence">精华</span>
          <!-- 准备放师徒圈图片的地方 -->
        </label>
        <label class="postView__post__time">{{dealWithTime(dic.create_time)}}</label>
        <p ref="content_all" :class="`postView__post__content ${showBtn && btnStatus === 'expand' ? 'all':''}`" v-html="getContent(escape(dic.content))">
        </p>
        <p v-if="showBtn" class="showAllBtn" @click.stop="expandClickEvent()">{{btnStatus === 'expand' ? "展开":"收起"}}</p>
        <p v-if="dic && dic.link_url && dic.link_url.includes(`works_detail.html`) && dic.remix && dic.owner.user !== '88820190449'" class="postView__post__content" v-html="getRemix">
        </p>
        <p class="postView__post__link" v-if="dic.link_url" @click.stop="jumpToWorkDetail(dic.link_url)">点击查看详情</p>
        <!-- 3d 模型 -->
        <div class="3dmodel" style="height:300px;" v-if="dic.model_url">
          <Model3D :url="dic.model_url"/>
        </div>
        <!-- 帖子图像 -->
        <ul class="postView__post__imgs" v-if="dic.images && dic.images.length">
          <li
            class="postView__post__img"
            v-for="(item, index) in dic.images"
            :key="index"
            @click.stop="openBigImg('photo', index)"
          >
            <img :src="getImg(item)" />
          </li>
        </ul>

        <!-- 图片浏览组件 -->
        <PreviewPhotos tag="photo" :data="dic.images" v-if="big_view.status" :index="big_view.index"/>

        <!-- 帖子视频 -->
        <div>
          <video
            class="bigImage__container__bigImg"
            v-if="dic.videos"
            controls
            controlslist="nodownload"
            ref="videoPlayer"
            x5-playsinline
            playsinline
            webkit-playsinline
            :src="dic.videos"
            :poster="dic.poster_url"
          ></video>
        </div>

        <!-- 习题 -->
        <QuestionDetail v-if="dic.question_json" :item="dic"/>

        <!-- 帖子按钮区 -->
        <div class="postView__post__btns" v-if="from !=='attention'">
          <div v-if="!dic.question_json" class="postView__post__btn postView__post__btn--comment" @click.stop="openInputEvent()">
            <img class="postView__post__btn__icon" :src="images.comment" />
            <span
              class="postView__post__btn__num"
            >{{dic.comment_count === 0?"评论":dic.comment_count}}</span>
          </div>
          <div
            v-if="!dic.question_json"
            class="postView__post__btn postView__post__btn--like"
            @click.stop="likeEvent(dic.is_like)"
          >
            <img
              class="postView__post__btn__icon"
              :src="dic.is_like?images.zan_select:images.zan_unselect"
            />
            <span class="postView__post__btn__num">{{dic.like_count === 0?"赞":dic.like_count}}</span>
          </div>
          <div
            v-if="!dic.is_self && !dic.question_json"
            class="postView__post__btn postView__post__btn--flower"
            @click.stop="sendFlower()"
          >
            <img
              class="postView__post__btn__icon"
              :src="dic.is_flower?images.flower_select:images.flower_unselect"
            />
            <span class="postView__post__btn__num sendFlower">{{dic.flower_count === 0?"送花":dic.flower_count}}</span>
          </div>
          <div
            v-if="dic.is_self || ownerInfo.is_staff"
            class="postView__post__btn postView__post__btn--delete"
            @click.stop="deletePost()"
          >
            <img
              class="postView__post__btn__icon"
              :src="images.delete_icon"
            />
            <span class="postView__post__btn__num">删除</span>
          </div>
          <div
            v-if="ownerInfo.is_staff"
            class="postView__post__btn postView__post__btn--sticky"
            @click.stop="stickyPost()"
          >
            <span class="postView__post__btn__num">{{dic.is_top ? "取消置顶": "置顶"}}</span>
          </div>
          <div
            v-if="ownerInfo.is_staff && ['oj', 'cube', 'video', 'piskel'].includes(dic.types)"
            class="postView__post__btn postView__post__btn--essence"
            @click.stop="essencePost()"
          >
            <span class="postView__post__btn__num">{{dic.is_essence ? "取消精华": "精华"}}</span>
          </div>
          <div
            v-if="ownerInfo.is_staff && ['video'].includes(dic.types)"
            class="postView__post__btn postView__post__btn--essence"
            @click.stop="homePost()"
          >
            <span class="postView__post__btn__num">{{dic.is_home_video ? "取消上首页": "上首页"}}</span>
          </div>
          <!-- <span class="postView__post__btn__forward" v-if="dic.types==='work' && dic.is_self" @click.stop="forwardEvent()">转发至朋友圈</span> -->
        </div>
      </div>
      <!-- 帖子评论区 -->
      <div class="postView__comment" v-if="openInput || showComment">
        <InputView type="comment" :avatar="ownerInfo.avatar" />
        <!-- <Comments :owner-info="ownerInfo" :post-item="dic" :from="from"/> -->

        <template v-if="dic.hasOwnProperty('comments')">
        <div class="commentView__items">
          <div class="commentView__items--comments" v-for="(item, index) in dic.comments" :key="item.pk">
            <ReplyItem
              type="comment"
              :has-line="(index !== dic.comments.length-1) && (!item.replys || item.replys.length === 0)"
              :item="item"
              :owner-info="ownerInfo"
            />
            <div class="commentView__items--replys">
              <Replys 
                :owner-info="ownerInfo" 
                :comment-item="item" 
              />
              <!-- <ReplyItem
                type="reply"
                :has-line="replyIndex !== item.replys.length-1"
                :item="replyItem"
                v-for="(replyItem, replyIndex) in item.replys"
                :key="replyItem.pk"
                :owner-info="ownerInfo"
              /> -->
            </div>
          </div>
        </div>
        <div v-if="dic.real_comment_count > dic.comments.length" :class="`commentView__loadMore ${dic.comments.length && dic.comments[dic.comments.length-1].replys.length === 0 ? 'borderTop': ''}`" @click.stop="loadMoreComment()">查看更多</div>
        </template>
      </div>
    </div>
    <div class="postHandles" v-if="!dic.is_self">
      <div :class="`postHandles__followBtn ${dic.is_follow?'unselect':''}`" @click.stop="followEvent(dic.is_follow)">
        <!-- <em class="postHandles__followBtn__icon">+</em> -->
        <!-- <span class="postHandles__followBtn__text">关注</span> -->
        <span class="postHandles__followBtn__text">{{dic.is_follow?"取消关注":"关注"}}</span>
      </div>
    </div>

    <!-- 全屏图片浏览视图 -->
    <PreviewPhotos ref="shadowPhotos" />
  </div>
</template>
<script>
import ReplyItem from "./ReplyItem.vue";
import InputView from "./InputView.vue";
import PreviewPhotos from './PreviewPhotos.vue';
import QuestionDetail from '../components/QuestionDetail.vue';
import Model3D from '../components/Model3D.vue'
import Replys from './Replys.vue'
import Comments from '../components/Comments.vue'

import {
  IMG_COMMENT,
  IMG_ZAN_UNSELECT,
  IMG_ZAN_SELECT,
  VIDEO_PLAY,
  IMG_DELETE_ICON,
  IMG_FLOWER,
  IMG_FLOWER_UNSELECT,
  IMG_FLOWER_SELECT
} from "../../assets";
import {Utils} from '../../utils';

import { types as LoginTypes } from "@/store/modules/login";
import { types as CommunityTypes } from "@/store/modules/community";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "PostItem",
  components: {
    ReplyItem,
    InputView,
    PreviewPhotos,
    QuestionDetail,
    Model3D,
    Replys,
    Comments
  },
  props: {
    dic: {
      type: Object
    },
    ownerInfo: {
      type: Object
    },
    showComment:{
      type: Boolean,
      default: false
    },
    from:{
      type: String,
      default:""
    }
  },
  data() {
    return {
      openInput: false,
      images: {
        comment: IMG_COMMENT,
        zan_unselect: IMG_ZAN_UNSELECT,
        zan_select: IMG_ZAN_SELECT,
        video_play:VIDEO_PLAY,
        delete_icon:IMG_DELETE_ICON,
        flower:IMG_FLOWER,
        flower_unselect: IMG_FLOWER_UNSELECT,
        flower_select: IMG_FLOWER_SELECT
      },
      big_view: {
        status: false,
        index: 0,
        type:'photo'
      },
      initContentHeight:94,
      showBtn:false,
      btnStatus:'expand', //expand, collapse   
      showSwiperView:false,
    };
  },
  computed: {
    // 获取 remix
    getRemix(){
      let remix = this.dic.remix;
      console.log(remix)
      let author = remix.split("的作品")[0]
      let work_name = remix.split("的作品")[1]
      let work_link = this.dic.remix_link
      console.log(remix, author, work_name)
      if(!author.includes('“')){
        author = `“${author}`
      }
      if(!author.includes('”')){
        author = `${author}”`
      }

      return `来源于${author}的作品<a target="_blank" href="${work_link}" style="text-decoration: none;">${work_name}</a>`
    },
  },

  methods: {
    ...mapActions({
      dependLoginStatus: LoginTypes.LOAD_LOGIN_STATUS,
      fetchCommentList: CommunityTypes.FETCH_COMMENT_LIST,
    }),
    ...Utils,
    getContent(result){
      let dic = this.dic;

      // 文字前面的 remix/原创 标签
      let temp_remix = ""
      if(dic && dic.link_url && dic.link_url.includes("works_detail.html")){
        let temp_text = "原创"
        if(dic.remix){
          temp_text = "Remix"
        }
        if(dic.owner.user === '88820190449'){
          temp_text = ""
        }
      
        if(temp_text){
          temp_remix = `<span class="remix" style="border: solid 1px #FF7B00; border-radius: 15px; color: #FF7B00; padding: 1px 5px;margin-right: 5px;font-size: 10px;">${temp_text}</span>`
        }
      }

      // 文字前面的公司标签
      let temp_content = ""
      if(dic && dic.company_data){
        temp_content = `<span style="color:#5024fe;">#${dic.company_data.name}#</span>`
      }

      // 视频前面的标题
      let temp_title = ""
      if(dic && dic.title){
        temp_title = `<span style="color:#333333;">【${dic.title}】</span>`
      }

      // 文字前面的学校标签
      let temp_school = ""
      if(dic && dic.school_data){
        temp_school = `<span style="color:#5024fe;">#${dic.school_data.name}#</span>`
      }
      return temp_school + temp_title + temp_remix + temp_content + result
    },
    //展开、收起事件(帖子描述)
    expandClickEvent(){
      if(this.btnStatus === 'expand'){
        this.btnStatus = 'collapse'
      }else if(this.btnStatus === 'collapse'){
        this.btnStatus = 'expand'
      }
    },
    //打开评论窗口
    openInputEvent() {
      if(this.showComment === true) return
      if(this.openInput === true){
        // 关闭
        this.openInput = false
      }else{
        // 打开，请求评论数据
        // console.log("请求该贴的评论数据")
        this.fetchCommentList({pk: this.dic.pk, page:1}).then(response=>{
          // this.dic["comments"] = response.results
          this.openInput = true
        })
      }
      // this.openInput = !this.openInput;
    },
    //打开大图浏览
    openBigImg(type, index=0) {
      this.big_view.type = type;
      this.big_view.index = index;
      this.big_view.status = true;
    },
    //关闭大图
    closeBigImg() {
      this.big_view.status = false;
    },
    // 打开全屏图片浏览视图
    openShadowPhotoView(data, index){
      this.$refs["shadowPhotos"].showShadowView(data, index);
    },
    
    //点赞帖子
    likeEvent(is_like) {
      let callback = ()=>{
      let data = { pk: this.dic.pk, is_like: is_like };
      if (this.$parent.likeEvent) {
        this.$parent.likeEvent("post", data);
      }
      }
      this.dependLoginStatus().then(callback)
    },
    // 置顶帖子
    stickyPost(){
      let callback = ()=>{
      let data = { pk: this.dic.pk };
      if (this.$parent.stickyPost) {
        this.$parent.stickyPost("post", data);
      }
      }
      this.dependLoginStatus().then(callback)
    },
    // 加精帖子
    essencePost(){
      let callback = ()=>{
      let data = { pk: this.dic.pk };
      if (this.$parent.essencePost) {
        this.$parent.essencePost("post", data);
      }
      }
      this.dependLoginStatus().then(callback)
    },
    // 上首页帖子(针对的是视频帖子 copy 到视频课程中)
    homePost(){
      let callback = ()=>{
      let data = { pk: this.dic.pk };
      if (this.$parent.homePost) {
        this.$parent.homePost("post", data);
      }
      }
      this.dependLoginStatus().then(callback)
    },
    //删除帖子
    deletePost() {
      let callback = ()=>{
      let data = { pk: this.dic.pk };
      if (this.$parent.deleteEvent) {
        this.$parent.deleteEvent("post", data);
      }
      }
      this.dependLoginStatus().then(callback)
    },
    //帖子送花
    sendFlower(){
      let callback = ()=>{
      let data = { pk: this.dic.pk};
      if(this.dic.is_flower === false && this.$parent.flowerEvent){
        this.$parent.flowerEvent("post", data);
      }
      }
      this.dependLoginStatus().then(callback)
    },
    //转发到朋友圈
    forwardEvent(){
      let callback = ()=>{
      let data = { pk: this.dic.pk};
      if(this.$parent.flowerEvent){
        this.$parent.forwardEvent("post", data);
      }
      }
      this.dependLoginStatus().then(callback)
    },
    // 关注/取关事件
    followEvent(is_follow){
      let callback = ()=>{
      let data = {"followers":[this.dic.owner.user], "is_follow":is_follow}
      if(this.$parent.followEvent){
        this.$parent.followEvent("post", data)
      }
      }
      this.dependLoginStatus().then(callback)
    },
    //跳到个人主页
    jumpToProfile(){
      let user_id = this.dic.owner.user_id;
      this.$router.push(`/profile/${user_id}`);
    },
    //跳到作品详情页
    jumpToWorkDetail(url){
      window.open(url, "_blank")
    },
    // 加载更多评论
    loadMoreComment(){
      if(this.$parent.loadMoreComment){
        this.$parent.loadMoreComment(this.dic.pk);
      }
    },

    //----------子组件 ReplyItem 的回调函数
    //点赞评论或回复
    likeReplyEvent(type, data) {
      let callback = ()=>{
      if (this.$parent.likeEvent) {
        this.$parent.likeEvent(type, data);
      }
      }
      this.dependLoginStatus().then(callback)
    },
    // 删除事件
    deleteReplyEvent(type, data) {
      let callback = ()=>{
      if (this.$parent.deleteEvent) {
        this.$parent.deleteEvent(type, data);
      }
      }
      this.dependLoginStatus().then(callback)
    },
    // 送花事件
    flowerReplyEvent(type, data){
      let callback = ()=>{
      if (this.$parent.flowerEvent) {
        this.$parent.flowerEvent(type, data);
      }
      }
      this.dependLoginStatus().then(callback)
    },
    
    //对评论的回复或对回复的回复
    publishReply(type, data) {
      let callback = ()=>{
      if (this.$parent.publish) {
        this.$parent.publish(type, data);
      }
      }
      this.dependLoginStatus().then(callback)
    },
    // 关注事件
    followReplyEvent(type, data){
      let callback = ()=>{
      if (this.$parent.followEvent) {
        this.$parent.followEvent(type, data);
      }
      }
      this.dependLoginStatus().then(callback)
    },

    //--------子组件 InputView组件的回调函数
    //对帖子评论
    publish(type, data) {
      let callback = ()=>{
      data["post"] = this.dic.pk;
      if (this.$parent.publish) {
        this.$parent.publish(type, data);
      }
      }
      this.dependLoginStatus().then(callback)
    }
  },
  create() {},
  mounted() {
    if(this.$refs.content_all.clientHeight > this.initContentHeight){
      this.showBtn = true;
    }
  }
};
</script>




<style lang="less" scoped>
.post {
  padding: 10px 15px;
  width: calc(100% - 30px);
  /* background-color: orange; */
  /* margin-bottom: 10px; */

  display: flex;
  flex-direction: row;
  position: relative;
}
.post__avatar1 {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  /* background-color: red; */
  margin-right: 10px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  cursor: pointer;
}
.post__avatar1 img {
  width: 100%;
  height: 100%;
}
.post__avatar {
  position: relative;
  display: flex;
  justify-content: center;
  margin-right: 10px;
  cursor: pointer;
  width: 30px;
  height: 50px;
  z-index: 90;
}
.post__avatar__bg{
  /* height: 80px; */
  height: 100%;
  position: relative;
  z-index: 100;
}
.post__avatar__img {
  /* top:20%; width:66.7% */
  position: absolute;
  top: 15%;
  left: calc((100% - 50px) / 2 + 1px);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  z-index: 99;
}
.postView {
  flex: 1;
  width:calc(100% - 60px);
}
.postView__post {
  color: #333333;

  display: flex;
  flex-direction: column;
  position: relative;
  /* max-width: 464px; */
}
.postView__post__delete {
  position: absolute;
  right: 0;
  top: 0;
  color: #333333;
  font-size: 12px;
  cursor: pointer;
}
.postView__post__name {
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 7px;
  margin: 0 0 3px;
  padding: 5px 0 0;
  cursor: pointer;
  color: #333333;
  display: flex;
  flex-direction:row;
  align-items: center;
  .name{
    height: 20px;
    line-height: 20px;
    overflow: hidden;
    max-width: 70%;
    display: inline-flex;
  }
}
.postView__post__name:hover{
  color: #eb7350;
}
.postView__post__segment{
  /* color: #5F0AFF; */
  /* font-size: 12px; */
  color: #666666;
  font-size: 11px;
  margin-left: 3px;
  font-weight: normal;
}
.postView__post__essence,
.postView__post__sticky{
  padding: 2px 8px;
  background-color: #dd3c53;
  border-radius: 15px;
  font-size: 10px;
  color: #ffffff;
  margin-left: 10px;
}
.postView__post__essence{
  background-color: #ff7b00;
}
.postView__post__time {
  margin-bottom: 2px;
  color: #808080;
  font-size: 12px;
}
.postView__post__content {
  margin-bottom: 2px;
  /* padding: 1px 0 3px; */
  line-height: 23px;
  word-wrap: break-word;
  word-break: break-word;
  font-size: 12px;
  /* overflow: hidden; */
  /* display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; */
  /* line-height: 20px;
  max-height: 60px; */
}
.postView__post__content.all{
  /* display: none; */
  /* line-height: initial;
  max-height: initial; */

  // line-height: 20px;
  max-height: 94px;
  overflow: hidden;
}
.showAllBtn{
  color: #6b45e1;
  cursor: pointer;
  padding: 1px 0 3px;

  font-size: 14px;
}
.postView__post__link{
  color: #6b45e1;
  cursor: pointer;
  padding: 1px 0 3px;

  font-size: 14px;
}
.postView__post__imgs {
  display: flex;
  flex-wrap: wrap;
  margin: -4px 0 0 -4px;
  max-height: 228px;
  overflow: auto;
  max-width: 464px;
}
.postView__post__imgs::-webkit-scrollbar {
  display: none;
}
.postView__post__img {
  width: 110px;
  height: 110px;
  margin: 4px 0 0 4px;
  /* background-color: red; */
  border: solid 1px #f2f2f5;
  cursor: pointer;
}
.postView__post__img img {
  width: 100%;
  height: 100%;
}
.postView__post__btns {
  display: flex;
  flex-direction: row;
  // height: 40px;
  align-items: center;
  position: relative;
  .sendFlower{
   width:-webkit-fill-available;
  }
}
.postView__post__btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 15px;
  height: 40px;
  cursor: pointer;
}
.postView__post__btn__icon {
  /* width: 20px; */
  height: 15px;
  /* height: 20px; */
  /* background-color: red; */
  margin-right: 7px;
}
.postView__post__btn__num {
  font-size: 12px;
  color: #808080;
  display: inline-table;
}
.postView__post__btn__forward{
  background-color: #FF7B00;
  color: #ffffff;
  font-size: 12px;
  border-radius: 20px;
  padding: 3px 10px;
  position: absolute;
  right: 0;
  cursor: pointer;
}
.postView__post__btn--like {
}
.postView__post__btn--comment {
}
.postView__comment {
  background-color: #f2f2f5;
  border-radius: 5px;
  padding: 10px 20px;
  /* width: calc(100% - 40px); */
  width: 100%;
  margin-left: -40px;
}

.commentView__items {
  width: 100%;
}
.commentView__items--comments {
  width: 100%;
}
.commentView__items--replys {
  margin-left: 40px;
  padding: 0px 10px;
  width: calc(100% - 60px);
  background-color: #eaeaec;
}
.commentView__loadMore{
  display: block;
  height: 35px;
  line-height: 35px;
  text-align: center;
  margin-bottom: -10px;
  font-size: 12px;
  cursor: pointer;
  &.borderTop{
    border-top-style: solid;
    border-top-width: 1px;
    border-color: #d9d9d9;
  }
}
.remix{
  border: solid 1px #FF7B00;
  border-radius: 15px;
  color: #FF7B00;
  padding: 1px 6px;
}

/*
* 大图
*/
.bigImage__container {
  padding: 6px 20px 10px 70px;
  background-color: #f2f2f5;
  margin-left: -80px;
  margin-right: -10px;
}
.bigImage__container__bigImgWrapper {
  width: 100%;
}
.bigImage__container__bigImg {
  width: 100%;
  max-height: 300px;
  min-height: 100px;
}
/*
* 视频
*/
.postView__post__video {
  width: 110px;
  height: 110px;
  margin: -4px 0 0 -4px;
  background-color: #e1e1e1;
  border: solid 1px #f2f2f5;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.postView__post__video__btn--play{
  width: 25px;
}
.post:hover{
  .postHandles{
    display: block;
  }
}
.postHandles{
  display: none;
  position: absolute;
  right: 15px;
  top: 10px;
  .postHandles__followBtn{
    // border: solid 1px #d9d9d9;
    padding: 3px 10px;
    // color:#333333;
    font-size: 12px;
    // box-shadow: 0px 1px 2px rgba(0,0,0,0.1);
    cursor: pointer;
    color: #FF7B00;
    border: solid 1px #FF7B00;
    border-radius: 15px;
    &.unselect{
      color: #888888;
      border-color: #888888;
    }
  }
  .postHandles__followBtn__icon{
    color: #fa7d3c!important;
    margin-right: 4px;
  }
  .postHandles__followBtn__text{

  }
}


.swiperShadowView{
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10000001;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.swiperContainer{
  /* height:300px; */
  background-color:#f2f2f5;
  height: 80%;
}
</style>